import { newWebAction } from "../../../../../../common/factory/action.factory";
import { addNewVariable } from "../../../../../../common/factory/variable.factory";
import { ActionRenderOptions } from "../../../../../../common/constants/core/action.constants";
import { PaginationType } from "../../../../../../common/interfaces/flow/action/WebRequestAction";
import { createFlowPayload,createFlowInstance} from "../../../payload/generic.flow"
import {createPagination} from "../../../../../../integrations/flow/edit/action/tabs/behavioursTab/pagination/utils/paginationUtil"
import importMappingConfig from "./userImportMappingConfig.json"
export const createUserImportFlowPayload = (scheduleCron,importSourceName, assetSchema, objectTypeName, workspaceId, importSourceId,importCredentialObject,patTokenCredentialObject) => {
    
    //init flow
    let flow = createFlowInstance(scheduleCron,
        "Jira Asset Import: Jira Users",
        "This integration imports Jira Users into Jira Assets and place them in the Asset Schema: "+assetSchema.label+" in the Object Type: "+objectTypeName+"\nThe Import Source is called "+importSourceName)

    //console.log(flow)
    //create custom get data, e.g fetch jira users
    const getUsers = newWebAction(flow, "Get Jira Users", null, ActionRenderOptions[0].value);
    getUsers.method = "GET"
    getUsers.url = "{{baseUrl}}/rest/api/2/users/search?startAt={{startAt}}&maxResults=200";
    getUsers.credentialsReference = patTokenCredentialObject
    const paginateScript = "const incrementValue=200; const startValue=0;\n          return startAt !== undefined ? startAt + incrementValue : startValue;"
    let pagination = createPagination(PaginationType.AUTO_INCREMENT,"startAt",paginateScript)
    pagination.enabled = true
    getUsers.pagination = pagination

    //create custom submit data for how the data is submitted, note body needs to match the selector. e.g users
    const submitUsers = newWebAction(flow, "Submit Users", getUsers.id, ActionRenderOptions[0].value);
    submitUsers.method = "POST"
    addNewVariable(submitUsers,"submitResultsUrl","$.links.submitResults")
    submitUsers.url = "{{submitResultsUrl}}"
    submitUsers.credentialsReference = importCredentialObject
    submitUsers.body = "{\n    \"data\":{\n        \"users\":{{{toJSON payload}}}\n    }\n}"

    //replace the input parametes in the json file
    importMappingConfig.schema.objectSchema.name = assetSchema.name
    importMappingConfig.schema.objectSchema.objectTypes[0].name = objectTypeName
    importMappingConfig.mapping.objectTypeMappings[0].objectTypeName = objectTypeName


    const customActionObjects = [{
        fetchAction: getUsers,
        childActions: [submitUsers]
    }]
    
    //console.log(importCredentialObject)
    const customImport = {
        importMappingConfig:JSON.stringify(importMappingConfig, null, 2),
        customActionObjects:customActionObjects
    }
    //console.log(customImport)
    return createFlowPayload(flow,
        workspaceId, 
        importSourceId,
        importCredentialObject,
        customImport)

}